import { cn } from "@/lib/utils";

export const SectionTitle = ({ eyebrow, title, subtitle, align = "left", className, ...rest }) => {
  const center = align === "center";
  return (
    <div className={cn("max-w-3xl", center && "mx-auto text-center", className)} {...rest}>
      {eyebrow && (
        <div className="font-condensed text-sm font-semibold uppercase tracking-[0.2em] text-brand mb-2">
          {eyebrow}
        </div>
      )}
      <h2 className="display-title text-4xl sm:text-5xl">{title}</h2>
      {subtitle && (
        <p className="mt-3 text-muted-foreground text-base sm:text-lg leading-relaxed">{subtitle}</p>
      )}
    </div>
  );
};
